"use client"

const metricas = [
  { valor: "9", label: "módulos en un solo sistema" },
  { valor: "24h", label: "para estar operando" },
  { valor: "100%", label: "en la nube, sin instalar" },
  { valor: "1", label: "plataforma, cero parches" },
]

export function SocialProof() {
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-[#004d52] text-white">      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-8 sm:mb-12">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold mb-3 text-balance px-2">            Construido para la operación real de una clínica dental
          </h2>
          <p className="text-white/70 text-sm sm:text-base">
            Cada módulo responde a un proceso que ya vives hoy.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 max-w-4xl mx-auto">
          {metricas.map(({ valor, label }) => (
            <div key={label} className="text-center px-1">
              <p className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-1">{valor}</p>
              <p className="text-xs sm:text-sm text-white/60 leading-snug">{label}</p>            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
